import React from 'react';
import MainContent from '../../components/mainContent/MainContent';
import { ResumenIngresoCreationContent } from './components/ResumenIngresoCreationContent';

export default function ResumenIngresoCreation() {
    return (
        <MainContent
            component={<ResumenIngresoCreationContent />}
            titulo='Nuevo ingreso'
            noBackground
        />
    );

};
